import styled from "styled-components";

const SearchBar = styled.div`
  display: flex;
  border-radius: 3px;
  margin-bottom: 1rem;
`;

export default SearchBar;
